import { SignAgreementsDto } from 'src/api/basketService';
import { OrderedList } from 'src/components/ordered-list/types';
import { LanguagesCode } from 'src/i18n/constants';

export type AgreementsPageProps = {
    onGoBack: () => void;
    hasRoommates: boolean;
    onSubmit: (agreementsData: SignAgreementsDto) => void | Promise<void>;
    loading: boolean;
    error: Error | null;
    adminFee: boolean;
    hideBackButton: boolean;
};

export type TermsItem = {
    header: string;
    text?: string;
    orderedList?: OrderedList[];
    intro?: string;
    outro?: string;
    bottomText?: string;
    subtitle?: string;
    introUnstyledText?: string;
};

export type BookingTermsWithLanguages = {
    languages: Record<
        LanguagesCode,
        {
            header: string;
            items: TermsItem[];
        }
    >;
};

export type BookingTerms = {
    [countryCode: string]: BookingTermsWithLanguages;
};

export enum BookingCountry {
    UK = 'united-kingdom',
    Spain = 'spain',
}
